import React, { useState, useEffect } from 'react';
import '../estilos/Zoom.css';
import ImgCarrusel from '../img-etc/Img_carrusel.jpeg'

import { useTranslation } from 'react-i18next';

function ImagenAnimada() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  const slides = [
    {
      img: "https://okdiario.com/img/viajes/2016/07/28/costa-rica.jpg",
      title: t('carrusel_titulo1'),
      subtitle: t('carrusel_sub1')
    },
    {
      img: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=2064&auto=format&fit=crop",
      title: t('carrusel_titulo2'),
      subtitle: t('carrusel_sub2')
    },
    {
      img: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=2064&auto=format&fit=crop",
      title: t('carrusel_titulo3'),
      subtitle: t('carrusel_sub3')
    }
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-carousel">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? 'active' : ''}`}
        >
          <img
            src={slide.img}
            alt={slide.title}
            className="HeroImage zoom-animation"
          />

          <div className="hero-text">
            <h1>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ImagenAnimada;
